export default "__VITE_ASSET__a30db445__"